var ls = require('./loggerSendQueue');
var logLevel = ls.logLevel;
var loggerSendQueue = ls.loggerSendQueue;
var DateTime = require('../datetime');

/**
 * Page-navigation tracker.
 *
 * Pushes a PageView entry into the shared loggerSendQueue on every Angular
 * route change. Navigation events are batched together with regular app logs
 * and flushed in a single POST once the shared buffer reaches apiBufferSize (20).
 *
 * Each entry records: destination URL, source URL, studyId extracted from
 * either URL, and time spent on the previous page (ms).
 */
var navigationTracker = (function () {
	'use strict';

	var lastNavTime = null;

	function extractStudyId(url) {
		if (!url) { return ''; }
		var match = url.match(/[?&]study=(\d+)/i);
		return match ? match[1] : '';
	}

	return {
		/**
		 * Record a navigation from fromUrl to toUrl by pushing a single info-level
		 * entry into the shared loggerSendQueue. The queue handles buffering (20)
		 * and the POST to /api/v1/logs — no separate HTTP call is made here.
		 */
		track: function (fromUrl, toUrl, appConfig, tokenService) {
			var now = new Date();
			var studyId = extractStudyId(toUrl) || extractStudyId(fromUrl);
			var timeOnPageMs = lastNavTime ? (now.getTime() - lastNavTime.getTime()) : null;

			var msg = 'PageView: ' + (toUrl || window.location.href);
			if (fromUrl)            { msg += ' from=' + fromUrl; }
			if (studyId)            { msg += ' study=' + studyId; }
			if (timeOnPageMs !== null) { msg += ' timeOnPage=' + timeOnPageMs + 'ms'; }

			lastNavTime = now;

			loggerSendQueue.getInstance(appConfig, tokenService).push(
				[msg],
				DateTime.formattedDateTimeNow(),
				logLevel.info,
				null
			);
		}
	};

})();

module.exports = navigationTracker;
